import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-background-100">
          <i className="ri-error-warning-line text-4xl text-foreground-400" style={{ width: 40, height: 40 }} />
        </div>
        <h1 className="font-heading text-3xl text-foreground-950 mb-3">
          {t('notFoundTitle')}
        </h1>
        <p className="text-foreground-600 mb-8">
          {t('notFoundText')}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          {t('notFoundCta')}
        </Link>
      </div>
    </div>
  );
}